/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ThreadsControllerDeleteMutationResponse, ThreadsControllerDeletePathParams, ThreadsControllerDelete401, ThreadsControllerDelete403, ThreadsControllerDelete404 } from "../../models/threadsController/ThreadsControllerDelete";

function getThreadsControllerDeleteUrl(threadId: ThreadsControllerDeletePathParams["threadId"]) {
  const res = { method: 'DELETE', url: `/api/v1/threads/${threadId}` as const }  
  return res
}

/**
 * @description Soft delete a thread. The thread will be marked as deleted but can be restored by backend if needed.
 * @summary Delete a thread
 * {@link /api/v1/threads/:threadId}
 */
export async function threadsControllerDelete(threadId: ThreadsControllerDeletePathParams["threadId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ThreadsControllerDeleteMutationResponse, ResponseErrorConfig<ThreadsControllerDelete401 | ThreadsControllerDelete403 | ThreadsControllerDelete404>, unknown>({ method : "DELETE", url : getThreadsControllerDeleteUrl(threadId).url.toString(), ... requestConfig })  
  return res.data
}